<template>
  <div class="banner">
    <!-- <swiper :options="swiperOption"> -->
		<!-- <swiper-slide> -->
			<img src="../assets/index/banner.jpg"  width="100%">
		<!-- </swiper-slide> -->
		<!-- <swiper-slide>
			<img src="../assets/index/banner_game.jpg"  width="100%" @click='show'>
		</swiper-slide> -->
		<!-- <div class="swiper-pagination"></div> -->
		 <!-- 如果需要分页器 -->
    	<!-- <div class="swiper-pagination"  slot="pagination"></div> -->
    <!-- </swiper> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
	data() {
		return {
			swiperOption: {
				autoplay: {  // 自动播放
					delay: 3000,
				},
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					clickable :true, //点击圆点控制展示某张图片
					type: 'bullets', //圆点形
					renderCustom: function(swiper,current, total){ 
						var paginationHtml = "";
						for(var i= 0; i< total; i++) {
							// 判断是不是激活焦点，是的话添加active类，不是就只添加基本样式类
							if(i === (current -1)){
								paginationHtml+= '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
							}else{
								paginationHtml+= '<span class="swiper-pagination-customs"></span>';
							}							
						}
						return paginationHtml;
					}
				}
			}
		}
	},
	methods: {
		show(){
			// this.$emit('show')
			this.$router.push('/activity')
		}	
	},
	components: {
      swiper,
      swiperSlide
  },
}
</script>
<style lang="less">
	.banner img{display: block;}
	.swiper-pagination-bullet{
		display: inline-block !important;
		width:45px !important;
		height:5px !important;
		background-color: #333 !important;
		opacity:0.2 !important;
		margin:0 5px 20px !important;
		border-radius: 0% !important;
	}
	.swiper-pagination-bullet-active{
		background-color: #b6000d !important;
		opacity:1 !important
	}

</style>